var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Description"
    },
    model: {
      value: _vm.modalDesc.show,
      callback: function callback($$v) {
        _vm.$set(_vm.modalDesc, "show", $$v);
      },
      expression: "modalDesc.show"
    }
  }, [_vm._v(" " + _vm._s(_vm.modalDesc.data || '-') + " ")]), _c('b-modal', {
    attrs: {
      "title": "Import Data",
      "ok-title": "Submit"
    },
    on: {
      "ok": _vm.handleImport
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-primary"
        }, [_vm._v("Import Data")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModalImport = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModalImport,
      callback: function callback($$v) {
        _vm.showModalImport = $$v;
      },
      expression: "showModalImport"
    }
  }, [[_c('div', {
    staticClass: "flex flex-column align-items-center"
  }, [_c('b-form-file', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": ".xlsx, .xls, .csv"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  }), _c('small', {
    staticClass: "text-black"
  }, [_vm._v("accept: .xlsx, .xls, .csv")])], 1), _c('b-button', {
    staticClass: "mt-3 w-100",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download Template ")])]], 2), _c('b-modal', {
    attrs: {
      "title": "Import Errors",
      "ok-only": "",
      "size": "lg"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('h5', {
          staticClass: "text-danger"
        }, [_vm._v("Import Failed - Error Details")]), _c('i', {
          staticClass: "fa fa-times cursor-pointer",
          on: {
            "click": function click($event) {
              _vm.showModalImportErrors = false;
            }
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showModalImportErrors,
      callback: function callback($$v) {
        _vm.showModalImportErrors = $$v;
      },
      expression: "showModalImportErrors"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("Row #")]), _c('th', [_vm._v("Error Message")])])]), _c('tbody', _vm._l(_vm.importErrors, function (error, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', [_vm._v(_vm._s(error))])]);
  }), 0)])])]), _c('b-col', {
    attrs: {
      "sm": "12"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("Equipment Category test")])])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        var _vm$equipmentCategory, _vm$equipmentCategory2;
        return [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('div', {
          staticClass: "d-flex mb-3"
        }, [_c('b-form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.fetchData.apply(null, arguments);
            }
          }
        }, [_c('b-form-input', {
          staticClass: "mr-2",
          staticStyle: {
            "width": "200px"
          },
          attrs: {
            "type": "text",
            "placeholder": "Search..."
          },
          on: {
            "input": _vm.debouncedSearch,
            "keyup": function keyup($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              return _vm.fetchData.apply(null, arguments);
            }
          },
          model: {
            value: _vm.equipmentCategory.params.search,
            callback: function callback($$v) {
              _vm.$set(_vm.equipmentCategory.params, "search", $$v);
            },
            expression: "equipmentCategory.params.search"
          }
        })], 1), _c('div', {
          staticStyle: {
            "width": "350px"
          }
        }, [_c('v-select', {
          attrs: {
            "id": "fleet",
            "multiple": "",
            "placeholder": "Select Vehicle Type",
            "label": "name",
            "options": _vm.typeFleet,
            "reduce": function reduce(opt) {
              return opt.code;
            }
          },
          model: {
            value: _vm.equipmentCategory.params.vehicleTypeIds,
            callback: function callback($$v) {
              _vm.$set(_vm.equipmentCategory.params, "vehicleTypeIds", $$v);
            },
            expression: "equipmentCategory.params.vehicleTypeIds"
          }
        })], 1), _c('div', {
          staticClass: "mx-2",
          staticStyle: {
            "width": "120px"
          }
        }, [_c('v-select', {
          attrs: {
            "id": "status",
            "placeholder": "Select Status",
            "label": "label",
            "options": _vm.statusOptions,
            "reduce": function reduce(opt) {
              return opt.value;
            },
            "clearable": false
          },
          model: {
            value: _vm.equipmentCategory.params.active,
            callback: function callback($$v) {
              _vm.$set(_vm.equipmentCategory.params, "active", $$v);
            },
            expression: "equipmentCategory.params.active"
          }
        })], 1), _c('div', [_c('b-button', {
          attrs: {
            "type": "button",
            "variant": "primary"
          },
          on: {
            "click": _vm.fetchData
          }
        }, [_c('i', {
          staticClass: "fa fa-sliders"
        }), _vm._v(" Apply Filter ")])], 1)], 1), _c('div', {
          staticClass: "d-flex"
        }, [_c('b-button', {
          staticClass: "d-flex align-items-center mr-2",
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.showModalImport = true;
            }
          }
        }, [_c('i', {
          staticClass: "ri-upload-2-line pl-1"
        }), _vm._v(" Import ")]), _c('b-button', {
          staticStyle: {
            "height": "max-content"
          },
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.openSidebar();
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-plus mr-1"
        }), _vm._v(" New Data ")])], 1)]), _c('div', {
          staticClass: "table-responsive"
        }, [(_vm$equipmentCategory = _vm.equipmentCategory.data) !== null && _vm$equipmentCategory !== void 0 && _vm$equipmentCategory.length ? _c('table', {
          staticClass: "table table-bordered table-striped"
        }, [_c('thead', {
          staticClass: "thead-light"
        }, [_c('tr', [_c('th', [_vm._v("Job Name")]), _c('th', [_vm._v("Used For")]), _c('th', [_vm._v("Description")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Status")]), _c('th', {
          staticClass: "text-center"
        }, [_vm._v("Action")])])]), _c('tbody', _vm._l(_vm.equipmentCategory.data, function (item, index) {
          return _c('tr', {
            key: index
          }, [_c('td', [_vm._v(_vm._s(item.component_name))]), _c('td', _vm._l(item.maintenance_component_vehicle_types, function (type, i) {
            var _type$vehicle_type;
            return _c('span', {
              key: i,
              staticClass: "badge badge-light border mr-1"
            }, [_vm._v(" " + _vm._s(type === null || type === void 0 ? void 0 : (_type$vehicle_type = type.vehicle_type) === null || _type$vehicle_type === void 0 ? void 0 : _type$vehicle_type.name) + " ")]);
          }), 0), _c('td', [_c('button', {
            staticClass: "btn btn-sm btn-outline-primary",
            on: {
              "click": function click() {
                _vm.modalDesc.show = true;
                _vm.modalDesc.data = item.description;
              }
            }
          }, [_vm._v(" Description ")])]), _c('td', {
            attrs: {
              "align": "center"
            }
          }, [item.active ? _c('span', {
            staticClass: "badge badge-primary"
          }, [_vm._v(" Active ")]) : _c('span', {
            staticClass: "badge badge-danger"
          }, [_vm._v("In Active")])]), _c('td', {
            attrs: {
              "align": "center"
            }
          }, [_c('b-dropdown', {
            attrs: {
              "size": "sm",
              "variant": "outline-primary",
              "text": "Action",
              "right": ""
            }
          }, [_c('b-dropdown-item', {
            on: {
              "click": function click($event) {
                $event.preventDefault();
                return _vm.openSidebar(item);
              }
            }
          }, [_vm._v(" Edit ")]), _c('b-dropdown-item', {
            staticClass: "text-danger",
            on: {
              "click": function click($event) {
                $event.preventDefault();
                return _vm.deleteItem(item);
              }
            }
          }, [_vm._v(" Delete ")])], 1)], 1)]);
        }), 0)]) : _c('div', {
          staticClass: "w-100 text-center py-5"
        }, [_c('p', {
          staticClass: "text-muted"
        }, [_vm._v("No Data Here!")])]), (_vm$equipmentCategory2 = _vm.equipmentCategory.data) !== null && _vm$equipmentCategory2 !== void 0 && _vm$equipmentCategory2.length ? _c('div', {
          staticClass: "mt-4 d-flex align-items-center w-100 justify-content-end"
        }, [_c('b-pagination', {
          staticClass: "mb-0 mr-3",
          attrs: {
            "total-rows": _vm.equipmentCategory.params.total,
            "per-page": _vm.equipmentCategory.params.limit,
            "first-number": "",
            "align": "center"
          },
          on: {
            "input": _vm.fetchData
          },
          model: {
            value: _vm.equipmentCategory.params.page,
            callback: function callback($$v) {
              _vm.$set(_vm.equipmentCategory.params, "page", $$v);
            },
            expression: "equipmentCategory.params.page"
          }
        }), _c('b-form-select', {
          staticStyle: {
            "width": "140px"
          },
          attrs: {
            "plain": "",
            "options": _vm.limitOptions
          },
          on: {
            "input": function input() {
              return _vm.fetchData();
            }
          },
          model: {
            value: _vm.equipmentCategory.params.limit,
            callback: function callback($$v) {
              _vm.$set(_vm.equipmentCategory.params, "limit", $$v);
            },
            expression: "equipmentCategory.params.limit"
          }
        })], 1) : _vm._e()])];
      },
      proxy: true
    }])
  })], 1), _c('custom-sidebar', {
    attrs: {
      "size": "lg",
      "title": "".concat(_vm.equipmentCategory.editMode ? 'Edit' : 'New', " Equipment Category")
    },
    model: {
      value: _vm.showSidebar,
      callback: function callback($$v) {
        _vm.showSidebar = $$v;
      },
      expression: "showSidebar"
    }
  }, [_c('b-form', {
    staticClass: "p-4 bg-white",
    staticStyle: {
      "border-radius": "10px"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Equipment Category Name *",
      "label-for": "project_location"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": "Equipment Category Name",
      "required": ""
    },
    model: {
      value: _vm.equipmentCategory.form.component_name,
      callback: function callback($$v) {
        _vm.$set(_vm.equipmentCategory.form, "component_name", $$v);
      },
      expression: "equipmentCategory.form.component_name"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Used For *",
      "label-for": "fleet"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "fleet",
      "multiple": "",
      "placeholder": "Select Vehicle Type",
      "label": "name",
      "options": _vm.typeFleet,
      "reduce": function reduce(opt) {
        return opt.code;
      }
    },
    model: {
      value: _vm.equipmentCategory.form.vehicle_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.equipmentCategory.form, "vehicle_type_ids", $$v);
      },
      expression: "equipmentCategory.form.vehicle_type_ids"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Description",
      "label-for": "Description"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "notes",
      "rows": "3",
      "placeholder": "Description"
    },
    model: {
      value: _vm.equipmentCategory.form.description,
      callback: function callback($$v) {
        _vm.$set(_vm.equipmentCategory.form, "description", $$v);
      },
      expression: "equipmentCategory.form.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Status *",
      "label-for": "active"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.equipmentCategory.form.active,
      callback: function callback($$v) {
        _vm.$set(_vm.equipmentCategory.form, "active", $$v);
      },
      expression: "equipmentCategory.form.active"
    }
  }, [_vm.equipmentCategory.form.active === false ? [_vm._v(" No ")] : [_vm._v("Yes")]], 2)], 1), _c('hr'), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "mr-3 w-50",
    attrs: {
      "type": "button",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.closeSidebar
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.equipmentCategory.editMode ? 'Save' : 'Add') + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }